module.exports = __webpack_public_path__ + "static/img/newvideo2.49895b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newvideo2.png
// module id = 2+t0
// module chunks = 208